import { SocketActions } from '@store/socketSaga'
import { call, put } from 'redux-saga/effects'

import Api from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { InternalThreadsActions, type ThreadsActions } from '../actions'

export function* deleteThread({
  payload: { id },
}: ReturnType<typeof ThreadsActions.delete>) {
  const internalAction = InternalThreadsActions.delete({ id })
  yield put(internalAction)

  yield call(Api.Threads.delete, id)
  sendGtmEvent(GtmTriggerName.DELETE_COMMENT)

  yield put(
    SocketActions.emit({
      eventName: 'comments',
      payload: internalAction,
    })
  )
}
